exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon-whatsapp {\n\n    color: #36acbb;\n}\n", ""]);

// exports
